// 平台助手首屏的推荐问题 (按当前所在菜单给; 没有对应菜单时给通用的).
// key 与 layout/menus.ts 的 MenuItem.key 对齐.

const GENERAL = [
    '我刚开始用这个平台, 应该从哪里开始?',
    '我提交了修改, 为什么数据没变?',
    '为什么页面上没有「新建」或「删除」按钮?',
    '审批通过了, 下游为什么还是看不到?',
    '3mm 椴木层板在 F1 Ultra 上的推荐参数是多少?',
];

const BY_MENU: Record<string, string[]> = {
    material: [
        '怎么新建一种材料?',
        '怎么批量修改材料的颜色或厚度?',
        '材料ID、xcode、SKU 是什么关系?',
        '改了一级类别, 理化参数为什么没了?',
    ],
    device: [
        '怎么新建一台设备?',
        '功率标定曲线怎么导入?',
        '怎么给设备配置加工模式?',
        '两台设备之间能换算参数吗?',
        'F1 Ultra 有哪些加工模式?',
    ],
    parameter: [
        '怎么批量导入参数?',
        '导入时提示「没有命中任何参数模板」怎么办?',
        '结果标 (推荐 / 不支持) 怎么改?',
        '参数模板怎么加一个字段?',
    ],
    gallery: ['效果图在哪里修改?', '矩阵图的行和列分别是什么?'],
    basedata: [
        '小贴士怎么批量挂到一类材料上?',
        '数据字典里禁用一个条目会影响已有数据吗?',
        '字段字典里的字段能修改吗?',
    ],
    apitoken: [
        'read 和 manage 令牌有什么区别?',
        '令牌申请了为什么调用报 40101?',
        '程序取数应该怎么接入?',
    ],
    myapprovals: ['我的工单被驳回了怎么办?', '怎么看我提交的工单进度?'],
    mypermissions: ['只读和管理权限有什么区别?', '怎么申请更多权限?'],
    assets: [
        'UGC 分享里的「加工前」图是怎么来的?',
        '材料加工的人工复核怎么做?',
    ],
    review: ['商品打标审核有哪些快捷键?', '打标审核和商品绑定材料是什么顺序?'],
};

export function suggestionsFor(menuKey?: string): string[] {
    return (menuKey && BY_MENU[menuKey]) || GENERAL;
}
